import React, { useMemo } from 'react';
import getGeolicalizedLabel from '../../../utils/getGeolicalizedLabel.js';
import useEtiquetas from '../../../hooks/useEtiquetas';
import transformWord from '../../../utils/transformWord';
import ParcelasDonutCard from './parcelas-donut-card';

// key is the geoFilter value of /admin/parcelas/list; geoLabel is what getGeolicalizedLabel returns for it
const GEO_ITEMS = [
  { key: 1, geoLabel: 'polígono', label: 'Con polígono', color: '#7F5918' },
  { key: 2, geoLabel: 'centroide', label: 'Solo centroide', color: '#F6DFB9' },
  { key: 3, geoLabel: 'sin geolocalizar', label: 'Sin geolocalizar', color: '#F4B037' },
];

// parcelas: rows from parcelas_all (see hooks/useParcelasAll)
const ParcelasResumenTotales = ({ parcelas, blocking }) => {
  const { etiquetas } = useEtiquetas();

  const geoCounts = useMemo(() => {
    const geoLabels = parcelas.map(item => getGeolicalizedLabel(item.poligono, item.centroide));
    return GEO_ITEMS.map(geo => geoLabels.filter(geoLabel => geoLabel === geo.geoLabel).length);
  }, [parcelas]);

  const parcelasLabel = transformWord(etiquetas?.parcela, ['plural', 'capitalize']);

  return (
    <ParcelasDonutCard
      title={`Total de ${parcelasLabel}`}
      total={parcelas.length}
      totalLabel={parcelasLabel}
      blocking={blocking}
      items={GEO_ITEMS.map((geo, index) => ({
        key: geo.key,
        label: geo.label,
        color: geo.color,
        value: geoCounts[index],
        to: { pathname: '/admin/parcelas/list', search: `?geoFilter=${geo.key}` },
      }))}
    />
  );
};

export default ParcelasResumenTotales;
